// @flow

import * as React from 'react';
import styles from './styles.scss';

type Props = {
  children: React.Node,
};

class FormField extends React.Component<Props> {
  static Label = ({ children }: { children: React.Node }): React.Node => (
    <div className={styles.fieldLabel}>{children}</div>
  );

  static Content = ({ children }: { children: React.Node }): React.Node => (
    <div className={styles.fieldInput}>{children}</div>
  );

  render(): React.Node {
    return (
      <div className={styles.formField}>
        {React.Children.map(
          this.props.children,
          (childElement: React.Element<any>): React.Node => React.cloneElement(childElement),
        )}
      </div>
    );
  }
}

export default FormField;



// WEBPACK FOOTER //
// ./src/components/FormField/index.js